import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import Seo from "../Components/Seo";

export default function Profile() {
  const navigate = useNavigate();
  const mobileNo = localStorage.getItem("userMobileNumber") || "";
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [details, setDetails] = useState({
    id: undefined,
    name: "",
    email: "",
    address: "",
    pin: "",
    profileImage: null,
  });

  useEffect(() => {
    if (!mobileNo) {
      navigate("/login");
      return;
    }
    const load = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/Product/GetUserProfile?mobileNo=${mobileNo}`);
        const data = await res.json();
        setDetails({
          id: data?.Id,
          name: data?.Name || "",
          email: data?.Email || "",
          address: data?.Address || "",
          pin: data?.Pincode ? String(data.Pincode) : "",
          profileImage: data?.ProfileImage || null,
        });
      } catch {
        setMsg("Profile load nahi hua");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [mobileNo, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg("");
    try {
      const res = await fetch(`${API_BASE_URL}/Product/UpdateProfile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Id: details.id,
          Name: details.name,
          MobileNo: mobileNo,
          Address: details.address,
          Email: details.email,
          PinCode: parseInt(details.pin || "0", 10) || 0,
          ProfileImage: null,
        }),
      });
      if (!res.ok) throw new Error();
      setMsg("✅ Profile save ho gayi!");
    } catch {
      setMsg("❌ Save nahi hua — dobara try karein");
    } finally {
      setSaving(false);
      setTimeout(() => setMsg(""), 3000);
    }
  };

  const social = (() => {
    try {
      return JSON.parse(localStorage.getItem("aio_social_profile") || "null");
    } catch {
      return null;
    }
  })();

  if (loading) {
    return <div style={{ textAlign: "center", padding: "60px", color: "#94a3b8", fontWeight: 600 }}>Loading profile...</div>;
  }

  return (
    <div style={{ maxWidth: "620px", margin: "0 auto", padding: "24px" }}>
      <Seo title="My Profile — Account Details" description="Apni AIO India profile dekhein aur update karein — naam, email, address aur pincode." path="/profile" />

      <h2 style={{ margin: "0 0 18px", fontSize: "24px", fontWeight: 800, color: "#0f172a" }}>My Profile</h2>

      <div style={{ ...card, textAlign: "center", marginBottom: "16px" }}>
        <div
          style={{
            width: "84px", height: "84px", borderRadius: "50%", margin: "0 auto 12px",
            background: "linear-gradient(135deg,#4f46e5,#7c3aed)", color: "#fff",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "34px", fontWeight: 800,
          }}
        >
          {(details.name || "U")[0].toUpperCase()}
        </div>
        <div style={{ fontWeight: 800, fontSize: "18px", color: "#0f172a" }}>{details.name || "User"}</div>
        <div style={{ fontSize: "13px", color: "#64748b" }}>📱 +91 {mobileNo}</div>
        {social?.email && (
          <div style={{ fontSize: "12px", color: "#7c3aed", marginTop: "4px", fontWeight: 600 }}>
            🔗 {social.provider?.replace(".com", "") || "Social"} — {social.email}
          </div>
        )}
      </div>

      <form onSubmit={handleSave} style={card}>
        <label style={label}>Naam</label>
        <input
          value={details.name}
          onChange={(e) => setDetails({ ...details, name: e.target.value })}
          placeholder="Aapka naam"
          style={input}
        />

        <label style={label}>Email</label>
        <input
          value={details.email}
          onChange={(e) => setDetails({ ...details, email: e.target.value })}
          placeholder="email@example.com"
          type="email"
          style={input}
        />

        <label style={label}>Address</label>
        <input
          value={details.address}
          onChange={(e) => setDetails({ ...details, address: e.target.value })}
          placeholder="Ghar / shop ka address"
          style={input}
        />

        <label style={label}>Pincode</label>
        <input
          value={details.pin}
          onChange={(e) => setDetails({ ...details, pin: e.target.value.replace(/\D/g, "").slice(0, 6) })}
          placeholder="6-digit pincode"
          inputMode="numeric"
          style={input}
        />

        {msg && <div style={{ marginTop: "12px", fontSize: "13px", fontWeight: 700, color: msg.includes("✅") ? "#16a34a" : "#dc2626" }}>{msg}</div>}

        <button
          type="submit"
          disabled={saving}
          style={{
            marginTop: "16px", width: "100%", padding: "13px", borderRadius: "12px",
            border: "none", background: "linear-gradient(135deg,#4f46e5,#7c3aed)",
            color: "#fff", fontWeight: 800, fontSize: "15px", cursor: "pointer",
            opacity: saving ? 0.7 : 1, boxShadow: "0 6px 16px rgba(79,70,229,0.35)",
          }}
        >
          {saving ? "Saving..." : "Save Profile"}
        </button>
      </form>

      <div style={{ ...card, marginTop: "16px", display: "flex", gap: "10px" }}>
        <button onClick={() => navigate("/settings")} style={{ ...btnGhost, flex: 1 }}>
          ⚙️ Settings
        </button>
        <button onClick={() => navigate("/myadds")} style={{ ...btnGhost, flex: 1 }}>
          📦 My Listings
        </button>
      </div>
    </div>
  );
}

const card = {
  background: "#fff", borderRadius: "16px", padding: "20px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
};
const label = { display: "block", fontSize: "13px", fontWeight: 700, color: "#475569", margin: "12px 0 6px" };
const input = {
  width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1px solid #e2e8f0",
  fontSize: "14px", outline: "none", color: "#0f172a", boxSizing: "border-box",
};
const btnGhost = {
  padding: "11px", borderRadius: "10px", border: "1px solid #e2e8f0",
  background: "#fff", color: "#334155", fontWeight: 700, fontSize: "14px", cursor: "pointer",
};
